import { render, staticRenderFns } from "./ImportItems.vue?vue&type=template&id=16aafad2&scoped=true"
import script from "./ImportItems.ts?vue&type=script&lang=ts&external"
export * from "./ImportItems.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aafad2",
  null
  
)

export default component.exports